import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ROIChart = ({ data, projectionYears = 20 }) => {
  const formatPercent = (value) => {
    return `${value?.toFixed(1)}%`;
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="caption font-medium text-foreground mb-2">Année {label}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center justify-between gap-4 mb-1">
              <span className="caption" style={{ color: entry?.color }}>
                {entry?.name}:
              </span>
              <span className="caption font-medium data-text" style={{ color: entry?.color }}>
                {formatPercent(entry?.value)}
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div>
      {/* Title and description are now handled by parent */}

      <div className="w-full h-64 md:h-80 lg:h-96" aria-label="Graphique de retour sur investissement">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={data}
            margin={{ top: 5, right: 10, left: 10, bottom: 5 }}
          >
            <defs>
              <linearGradient id="colorROI" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#7c3aed" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#7c3aed" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis
              dataKey="year"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '0.75rem', fontFamily: 'var(--font-caption)' }}
              label={{ value: 'Années', position: 'insideBottom', offset: -5, style: { fontSize: '0.75rem', fontFamily: 'var(--font-caption)' } }}
            />
            <YAxis
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '0.75rem', fontFamily: 'var(--font-caption)' }}
              tickFormatter={formatPercent}
            />
            <Tooltip content={<CustomTooltip />} />
            <Area
              type="monotone"
              dataKey="cumulativeROI"
              name="ROI cumulatif"
              stroke="#7c3aed"
              strokeWidth={3}
              fillOpacity={1}
              fill="url(#colorROI)"
              dot={false}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ROIChart;